<template>
  <section
    id="curriculum"
    class="co-bg-striped"
  >
    <div class="co-container-lg mx-auto px-4 py-20">
      <h2 class="co-heading-2-caption">
        短期間で結果を出す<br class="md:hidden">カリキュラム
      </h2>
      <p class="mb-[3.25rem] text-left md:text-center">
        あなたの現在の実力をもとに、もっとも効果的で無駄のないトレーニングメニューを設定します。
        <br class="hidden md:block">
        パーソナルメンターのメンタリングとオリジナル学習システムで目標到達まで最短距離で進みます。
      </p>
      <div class="mx-auto grid grid-cols-1 gap-x-20 gap-y-12 sm:max-w-[640px] lg:max-w-full lg:grid-cols-2">
        <div class="flex gap-x-5">
          <div class="mb-0 min-w-[50px] text-center">
            <img
              src="~/assets/images/Te/TeCourse/Ai/Curriculum/curriculum-python.png"
              alt="Python"
              width="48"
              height="48"
            >
          </div>
          <div>
            <h3 class="co-display-10 mb-4 font-bold">
              Python
            </h3>
            <p class="mb-0">
              機械学習でよく使われる言語で、機械学習系のライブラリが充実しています。
            </p>
          </div>
        </div>
        <div class="flex gap-x-5">
          <div class="mb-0 min-w-[50px] text-center">
            <img
              src="~/assets/images/Te/TeCourse/Ai/Curriculum/curriculum-pandas.png"
              alt="Pandas"
              width="48"
              height="48"
            >
          </div>
          <div>
            <h3 class="co-display-10 mb-4 font-bold">
              Pandas
            </h3>
            <p class="mb-0">
              Pythonのライブラリで、データの集計・分析を行う際に利用されています。
            </p>
          </div>
        </div>
        <div class="flex gap-x-5">
          <div class="mb-0 min-w-[50px] text-center">
            <img
              src="~/assets/images/Te/TeCourse/Ai/Curriculum/curriculum-scikit-learn.png"
              alt="scikit-learn"
              width="48"
              height="48"
            >
          </div>
          <div>
            <h3 class="co-display-10 mb-4 font-bold">
              scikit-learn
            </h3>
            <p class="mb-0">
              Pythonで書かれたオープンソース機械学習ライブラリで、回帰分析やクラスタリングなどを実行できるようになります。
            </p>
          </div>
        </div>
        <div class="flex gap-x-5">
          <div class="mb-0 min-w-[50px] text-center">
            <img
              src="~/assets/images/Te/TeCourse/Ai/Curriculum/curriculum-keras.png"
              alt="Keras"
              width="48"
              height="48"
            >
          </div>
          <div>
            <h3 class="co-display-10 mb-4 font-bold">
              Keras
            </h3>
            <p class="mb-0">
              Pythonで書かれたニューラルネットワークライブラリで、画像やテキストデータなどの分析で用いられます。
            </p>
          </div>
        </div>
        <div class="flex gap-x-5">
          <div class="mb-0 min-w-[50px] text-center">
            <img
              src="~/assets/images/Te/TeCourse/Ai/Curriculum/curriculum-tensor-flow.png"
              alt="TensorFlow"
              width="48"
              height="48"
            >
          </div>
          <div>
            <h3 class="co-display-10 mb-4 font-bold">
              TensorFlow
            </h3>
            <p class="mb-0">
              Googleが開発・公開している機械学習オープンソースライブラリで、画像認識や音声認識技術に利用されています。
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
